import { render, staticRenderFns } from "./appendForm.vue?vue&type=template&id=d81f9700&scoped=true&"
import script from "./appendForm.vue?vue&type=script&lang=js&"
export * from "./appendForm.vue?vue&type=script&lang=js&"
import style0 from "./appendForm.vue?vue&type=style&index=0&id=d81f9700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81f9700",
  null
  
)

export default component.exports